export const BLOCK_TYPE_PRODUCT_LIST_ALL = 'productListAll';
